"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedUserTagsData = exports.fetchPaginatedTags = exports.getSelectedUsersData = exports.fetchPaginatedUsers = exports.fetchTokens = exports.fetchServiceIdentities = exports.fetchGroups = exports.fetchUsers = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));

var _apiService = _interopRequireDefault(require("../../../utils/api-service"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var SINGLE_REQUEST_LIMIT = 50;

var fetchUsers = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _apiService.default.get('/api/users?type=User', {
              headers: {
                'content-type': 'application/json'
              }
            });

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchUsers() {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchUsers = fetchUsers;

var fetchGroups = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _apiService.default.get('/api/user-tags', {
              headers: {
                'content-type': 'application/json'
              }
            });

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchGroups() {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchGroups = fetchGroups;

var fetchServiceIdentities = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _apiService.default.get('/api/users?type=ServiceIdentity', {
              headers: {
                'content-type': 'application/json'
              }
            });

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchServiceIdentities() {
    return _ref3.apply(this, arguments);
  };
}();

exports.fetchServiceIdentities = fetchServiceIdentities;

var fetchTokens = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var response, tokens;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _apiService.default.get('/api/token/all', {
              headers: {
                'content-type': 'application/json'
              }
            });

          case 2:
            response = _context4.sent;
            tokens = response === null || response === void 0 ? void 0 : response.data;

            if (tokens && tokens.length) {
              tokens = tokens.filter(function (token) {
                var type = token.type;
                return type !== 'ServiceIdentity';
              });
            }

            return _context4.abrupt("return", tokens || []);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchTokens() {
    return _ref4.apply(this, arguments);
  };
}();

exports.fetchTokens = fetchTokens;

var fetchPaginatedUsers = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(params) {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _apiService.default.get('/api/users', {
              headers: {
                'content-type': 'application/json'
              },
              params: _objectSpread({
                type: 'User'
              }, params)
            });

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchPaginatedUsers(_x) {
    return _ref5.apply(this, arguments);
  };
}();

exports.fetchPaginatedUsers = fetchPaginatedUsers;

var getSelectedUsersData = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var users,
        userIds,
        userRequests,
        responses,
        consolidatedData,
        _args6 = arguments;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            users = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : [];

            if (!(0, _isEmpty.default)(users)) {
              _context6.next = 3;
              break;
            }

            return _context6.abrupt("return", []);

          case 3:
            userIds = [];
            (0, _uniqBy.default)(users, 'id').forEach(function (user) {
              if ((user === null || user === void 0 ? void 0 : user.name) !== 'Deleted member' && user.id !== '*') {
                userIds.push(user.id);
              }
            });

            if (!(userIds.length === 0)) {
              _context6.next = 7;
              break;
            }

            return _context6.abrupt("return", []);

          case 7:
            userRequests = [];

            while (userIds.length > 0) {
              userRequests.push(_apiService.default.post('/api/users/minimized-user-details', userIds.splice(0, SINGLE_REQUEST_LIMIT)));
            }

            _context6.next = 11;
            return _axios.default.all(userRequests);

          case 11:
            responses = _context6.sent;

            if (!(0, _isEmpty.default)(responses)) {
              _context6.next = 14;
              break;
            }

            return _context6.abrupt("return", []);

          case 14:
            consolidatedData = [];
            responses.forEach(function (response) {
              return consolidatedData = [].concat(_toConsumableArray(consolidatedData), _toConsumableArray(response.data));
            });
            consolidatedData.forEach(function (d) {
              d.userId = d.id;
              d.name = d.username;
            });
            return _context6.abrupt("return", consolidatedData);

          case 18:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getSelectedUsersData() {
    return _ref6.apply(this, arguments);
  };
}();

exports.getSelectedUsersData = getSelectedUsersData;

var fetchPaginatedTags = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(params) {
    var response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _apiService.default.get('/api/user-tags', {
              headers: {
                'content-type': 'application/json'
              },
              params: params
            });

          case 2:
            response = _context7.sent;
            return _context7.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function fetchPaginatedTags(_x2) {
    return _ref7.apply(this, arguments);
  };
}();

exports.fetchPaginatedTags = fetchPaginatedTags;

var getSelectedUserTagsData = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    var tags,
        tagIds,
        tagRequests,
        responses,
        consolidatedData,
        _args8 = arguments;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            tags = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : [];

            if (!(0, _isEmpty.default)(tags)) {
              _context8.next = 3;
              break;
            }

            return _context8.abrupt("return", []);

          case 3:
            tagIds = [];
            (0, _uniqBy.default)(tags, 'id').forEach(function (user) {
              if ((user === null || user === void 0 ? void 0 : user.name) !== 'Deleted Tag' && user.id !== '*') {
                tagIds.push(user.id);
              }
            });

            if (!(tagIds.length === 0)) {
              _context8.next = 7;
              break;
            }

            return _context8.abrupt("return", []);

          case 7:
            tagRequests = [];

            while (tagIds.length > 0) {
              tagRequests.push(_apiService.default.post('/api/user-tags/minimized-tag-details', tagIds.splice(0, SINGLE_REQUEST_LIMIT)));
            }

            _context8.next = 11;
            return _axios.default.all(tagRequests);

          case 11:
            responses = _context8.sent;

            if (!(0, _isEmpty.default)(responses)) {
              _context8.next = 14;
              break;
            }

            return _context8.abrupt("return", []);

          case 14:
            consolidatedData = [];
            responses.forEach(function (response) {
              return consolidatedData = [].concat(_toConsumableArray(consolidatedData), _toConsumableArray(response.data));
            });
            return _context8.abrupt("return", consolidatedData);

          case 17:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getSelectedUserTagsData() {
    return _ref8.apply(this, arguments);
  };
}();

exports.getSelectedUserTagsData = getSelectedUserTagsData;